export default defineNuxtPlugin(async (nuxtApp) => {
  nuxtApp.hook("app:mounted", () => {
    if (!import.meta.client) return;

    const { initUnexo } = useUnexo();
    
    initUnexo();
  });

  nuxtApp.hook("page:finish", () => {
    const unexo = useUnexo();
    const route = useRoute();

    unexo.pageView(route.fullPath);
  });
});
